import { Typography } from "@aircall/tractor";
import styled from "@xstyled/styled-components";

export const Utterance = styled(Typography).attrs({
  color: "text-base",
})`
  scroll-margin-top: 50px;
`;
